import { defineAsyncComponent } from 'vue'
export default {
  "admin-preview": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/adminPreview.vue")),
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue")),
  empty: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/empty.vue"))
}